import { OrderDto } from '../../../../models/order-dto';
import { OrderCompleteResponseDto } from '../../../../models/dtos/order-complete-response-dto';
import { OrderStepResolverAction } from '../../../../models/order-step-resolver-action.model';

export class InitOrderReviewStep implements OrderStepResolverAction {
  public static readonly type = '[OrderReviewStep] Init Order Review Step';
}

export class UpdateOrderReviewStep {
  public static readonly type = '[OrderReviewStep] Update Order Review Step';
}

export class SaveOrderReviewStep {
  public static readonly type = '[OrderReviewStep] Save Order Review Step';
}

export class StartOrderComplete {
  public static readonly type = '[OrderReviewStep] Start Order Complete';
}

export class OrderCompleteSucceeded {
  public static readonly type = '[OrderReviewStep] Order Completed Succeeded';

  constructor(public readonly payload: OrderCompleteResponseDto) {}
}

export class OrderCompleteEnded {
  public static readonly type = '[OrderReviewStep] Order Completed Ended';

  constructor(public readonly payload: OrderDto['id']) {}
}
